import { Component, OnInit, Inject } from '@angular/core';
import * as moment from 'moment';

import {MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import {MAT_DIALOG_DATA} from '@angular/material';
import { NestService } from '../../services/nest.service';
import { AdduserpetComponent } from '../adduserpet/adduserpet.component';
@Component({
  selector: 'app-coupon',
  templateUrl: './coupon.component.html',
  styleUrls: ['./coupon.component.css']
})
export class CouponComponent implements OnInit {
  newtotal: number;
  discamount: number;
  action: any;
  loading: any;
  total: any;
  nest: any;
  todaysdate: any;
  coupons: any;
  data = [];
  msg: any;
  constructor(private nestService: NestService, public snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data1,
 public dialogRef: MatDialogRef<AdduserpetComponent>) { 
  this.nest = data1.data;
  this.total = data1.data1
  console.log(this.nest, this.total);
  var dat = this.getDate();
  this.todaysdate = dat;
 }

  ngOnInit() {
    this.getCoupons();
  }

  getDate(){
    var today = new Date();
    var d:string;
    var m: string;
    var dd = today.getDate();
    var mm = today.getMonth()+1; //January is 0!
    var yyyy = today.getFullYear();
    var da:any;
   
  
    if(dd<10) {
      d = '0'+dd;
    } 
    else
      d= dd.toString();
  
    if(mm<10) {
      m = '0'+mm
    } 
    else
      m = mm.toString();
  
  
    da = yyyy + '-' + m + '-' + d
    return da.toString();
  }
  getCoupons(){
    this.nestService.getAllCoupon(this.nest)
    .subscribe((x)=>{
      for(let i = 0; i < x.length; i++){
        console.log(x[i].expiary);
        var date = moment(x[i].expiary);
        var now = moment(this.todaysdate);
    //    const dateMoment = moment(x[i].expiary, 'YYYY/MM/DD');
    //    const da = dateMoment.date();
        console.log(now, this.todaysdate);
        if(date >= now){
         this.coupons = x;
        }
      }
      console.log(this.coupons);
    });
  }

 

  addCoupon(minval, discount, id) {
    if (this.total >= minval) {
      this.newtotal = this.total - (this.total * discount / 100);
      this.discamount = this.total - this.newtotal;
      this.data.push({'total': this.newtotal, 'discamount': this.discamount, 'discount': discount, 'id': id})
      this.dialogRef.close(this.data);
    } else {
      this.msg = 'The Amount is less than the minimum value';
      this.showAlert();
    }

  }



  showAlert() {
    this.snackBar.open(this.msg, this.action , {
      duration: 4000,
    });
 }


}
